import React from "react"
import { StaticQuery, graphql } from "gatsby"

import SliderSlick from "react-slick"
import "./slider.scss"

import Img from "gatsby-image"

const Slider = () => {
  var settings = {
    customPaging: function(i) {
      return (
        <div className="slick-dots__dot">
          <div className="slick-dots__dot--active"></div>
        </div>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    easing: 'ease-out-quint',
    pauseOnHover: false,
  };
  return (
    <StaticQuery
      query={query}
      render={data => (
        <SliderSlick {...settings} className="slider-container">
          <Img fluid={data.one.childImageSharp.fluid} />
          <Img fluid={data.two.childImageSharp.fluid} />
          <Img fluid={data.three.childImageSharp.fluid} />
          <Img fluid={data.four.childImageSharp.fluid} />
          <Img fluid={data.five.childImageSharp.fluid} />
          <Img fluid={data.six.childImageSharp.fluid} />
          <Img fluid={data.seven.childImageSharp.fluid} />
        </SliderSlick>
      )}
    />
  );
}

export default Slider

export const fluidImage = graphql`
  fragment fluidImage on File {
    childImageSharp {
      fluid(maxWidth: 1920, quality: 100) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`;

export const query = graphql`
  query {
    one: file(relativePath: { eq: "slider/1.jpg" }) {
      ...fluidImage
    }
    two: file(relativePath: { eq: "slider/2.jpg" }) {
      ...fluidImage
    }
    three: file(relativePath: { eq: "slider/3.jpg" }) {
      ...fluidImage
    }
    four: file(relativePath: { eq: "slider/4.jpg" }) {
      ...fluidImage
    }
    five: file(relativePath: { eq: "slider/5.jpg" }) {
      ...fluidImage
    }
    six: file(relativePath: { eq: "slider/6.jpg" }) {
      ...fluidImage
    }
    seven: file(relativePath: { eq: "slider/7.jpg" }) {
        ...fluidImage
    }
  }
`
